"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-spring-manufacturing";
const IMAGE_BASE = "/image/new-version/more/SpringManufacturing/Applications";

const APPLICATIONS = [
	{ keyPrefix: "applicationsItem1", image: "automotive-industry.webp", highlighted: false, href: "/industry/automotive" },
	{
		keyPrefix: "applicationsItem4",
		image: "power-tools-industry.webp",
		highlighted: false,
		href: "/industry/industry-equipment",
	},
	{
		keyPrefix: "applicationsItem2",
		image: "3c-electronics-industry.webp",
		highlighted: false,
		href: "/industry/consumer-electronics",
	},
	{
		keyPrefix: "applicationsItem5",
		image: "smart-home-industry.webp",
		highlighted: false,
		href: "/industry/consumer-goods",
	},
	{
		keyPrefix: "applicationsItem3",
		image: "medical-device-industry.webp",
		highlighted: false,
		href: "/industry/medical-device",
	},
	{
		keyPrefix: "applicationsItem6",
		image: "fitness-equipment-industry.webp",
		highlighted: true,
		href: "/industry/consumer-goods",
	},
] as const;

export default function SpringManufacturingApplications() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<span className="mb-3 inline-block text-xl uppercase tracking-wider text-themePrimary400 max-md:text-lg">
						{t("applicationsEyebrow")}
					</span>
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("applicationsTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("applicationsDesc")}</p>
				</div>

				<div className="grid items-start gap-8 lg:grid-cols-[6fr_4fr] lg:gap-10 xl:gap-14">
					<div className="grid gap-x-10 gap-y-6 sm:grid-cols-2">
						{APPLICATIONS.map((item) => (
							<div key={item.keyPrefix}>
								<h3 className="mb-2 text-base font-semibold text-themePrimary400 sm:text-lg">
									{t(`${item.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${item.keyPrefix}Desc`)}</p>
							</div>
						))}
					</div>

					<div className="grid grid-cols-2 gap-3 self-start">
						{APPLICATIONS.map((item) => (
							<Link
								key={`${item.keyPrefix}Image`}
								href={item.href}
								className={`group flex min-h-32 flex-col rounded-xl p-4 transition-colors duration-300 ${
									item.highlighted
										? "bg-[#88d43c]"
										: "bg-[#ededed] hover:bg-themePrimary400"
								}`}
							>
								<div className="relative h-16 w-16 overflow-hidden rounded-full sm:h-20 sm:w-20">
									<Image
										src={`${IMAGE_BASE}/${item.image}`}
										alt={t(`${item.keyPrefix}ImageAlt`)}
										fill
										className="object-cover"
										sizes="80px"
									/>
								</div>
								<span className="mt-auto self-end text-right text-sm font-semibold text-[#1f1f1f] group-hover:text-white sm:text-base">
									{t(`${item.keyPrefix}Label`)}
								</span>
							</Link>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
